import React, { useState } from 'react';
import Header from './components/Header';
import HeroTerminal from './components/HeroTerminal';
import DashboardGrid from './components/DashboardGrid';
import KitBuilder from './components/KitBuilder';
import DataTables from './components/DataTables';
import InfoModules from './components/InfoModules';
import Footer from './components/Footer';
import Notification from './components/Notification';
import { AnimatePresence } from 'framer-motion';

function App() {
  const [notifications, setNotifications] = useState([]);

  const addNotification = (message, type) => {
    const id = Date.now();
    setNotifications(prev => [...prev, { id, message, type }]);
  };

  const removeNotification = (id) => {
    setNotifications(prev => prev.filter(n => n.id !== id));
  };

  return (
    <div className="min-h-screen flex flex-col selection:bg-electric selection:text-graphite-900">
      <Header />
      <main className="flex-grow">
        <HeroTerminal />
        <DashboardGrid onNotify={addNotification} />
        <KitBuilder onNotify={addNotification} />
        <DataTables />
        <InfoModules />
      </main>
      <Footer />

      <div className="fixed bottom-0 right-0 z-[100] p-6 pointer-events-none">
        <AnimatePresence>
          {notifications.map(notif => (
            <div key={notif.id} className="pointer-events-auto mb-4">
              <Notification 
                message={notif.message} 
                type={notif.type} 
                onClose={() => removeNotification(notif.id)} 
              />
            </div>
          ))}
        </AnimatePresence>
      </div>
    </div>
  );
}

export default App;